module.exports = "/_next/static/images/06c365039169afacc31e57cfde3de26a-bubble-gum-woman-square@lg-1x.jpg.webp";